// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"a21b2ece","990":"c6a7ee28"}[chunkId] + ".chunk.css";
};